import { render } from "./Appointment.vue?vue&type=template&id=1e86b7a3&scoped=true&ts=true"
import script from "./Appointment.vue?vue&type=script&lang=ts"
export * from "./Appointment.vue?vue&type=script&lang=ts"

import "./Appointment.vue?vue&type=style&index=0&id=1e86b7a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e86b7a3"]])

export default __exports__